/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetCommonState200ResponseData } from './GetCommonState200ResponseData'
import {
  GetCommonState200ResponseDataFromJSON,
  GetCommonState200ResponseDataFromJSONTyped,
  GetCommonState200ResponseDataToJSON,
} from './GetCommonState200ResponseData'

/**
 *
 * @export
 * @interface GetCommonState200Response
 */
export interface GetCommonState200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetCommonState200Response
   */
  status: boolean
  /**
   *
   * @type {GetCommonState200ResponseData}
   * @memberof GetCommonState200Response
   */
  data: GetCommonState200ResponseData
}

/**
 * Check if a given object implements the GetCommonState200Response interface.
 */
export function instanceOfGetCommonState200Response(
  value: object
): value is GetCommonState200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetCommonState200ResponseFromJSON(
  json: any
): GetCommonState200Response {
  return GetCommonState200ResponseFromJSONTyped(json, false)
}

export function GetCommonState200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCommonState200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetCommonState200ResponseDataFromJSON(json['data']),
  }
}

export function GetCommonState200ResponseToJSON(
  value?: GetCommonState200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetCommonState200ResponseDataToJSON(value['data']),
  }
}
